import { render, staticRenderFns } from "./TblWarning.vue?vue&type=template&id=1cb08782"
import script from "./TblWarning.vue?vue&type=script&lang=js"
export * from "./TblWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports